import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { ContentType, OrderDataAddressFieldInputs, OrderDataInputFields, RequiredServiceTypeFieled } from "../../shared/contentTypes";
import { CustomerInputFieldViewModel, WebshopSettingsDataModel2, WebshopSettingsDMKey } from "../../shared/models";
import { UserAddressViewModel, UserInfoData } from "../../shared/models/userInfo.model";
import Utils from "../../shared/utils";

@Injectable()
export class BillingInfoService {

  private _webshopSettingsObsServ: IObjectObserver<WebshopSettingsDataModel2>;
  public get webshopSettingsDataModelObserveChanges(): Observable<(string | number)[]> {
    return this._webshopSettingsObsServ.ObserveChanges;
  }

  constructor(private _circularInjectionHelper: CircularInjectionHelper) {
    this._webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, _circularInjectionHelper);
  }

  /**get user billig info to */
  public GetUserBillingInfo(): Promise<UserAddressViewModel> {
    const me = this;
    return new Promise<UserAddressViewModel>((resolve, reject) => {
      me._circularInjectionHelper.yourAppServer.User.GetUserInfo(true)
        .then((userInfo) => {
          resolve(me.mapUserInfoToUserAddressViewModel(userInfo));
        })
        .catch((error) => {
          reject();
          this._circularInjectionHelper.coreLogService.error("UserAddressService.GetUserInfoViewModel", "_circularInjectionHelper.yourAppServer.User.GetUserInfo()", error);
        });
    });
  }

  /**set the input base on all services in webshop
   * we need to show all fields for all services in billing info
   */
  public getAddressInputFields(): Promise<CustomerInputFieldViewModel[]> {
    const me = this;
    return new Promise<CustomerInputFieldViewModel[]>((resolve, reject) => {
      me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey)
        .then((webshopSettingsDataModel) => {
          const jsonInputs = JSON.parse(webshopSettingsDataModel.customer_input_fields) as Object[];
          const addressInputs = jsonInputs.filter(a => Object.keys(OrderDataAddressFieldInputs).includes(a["field"]));
          resolve(me.createCustomerInputFieldViewModel(addressInputs));
        })
        .catch(error => {
          this._circularInjectionHelper.coreLogService.error("BillingInfoService.getAddressInputFields", "._webshopSettingsObsServ.GetObject", error);
          reject(error);
        });
    })
  }

  private createCustomerInputFieldViewModel(jasonInputs: Object[]) {
    const me = this;
    const customerInputFieldViewModels = new Array<CustomerInputFieldViewModel>();
    //const filteredJsonInputs = jasonInputs.filter(j => j[UseServiceTypeField.UsedDelivery] || j[UseServiceTypeField.UsedPickUp] || j[UseServiceTypeField.UsedInHouse] || j[UseServiceTypeField.UsedWebvoucher]);
    jasonInputs.forEach(jsonObject => {
      if (Utils.EnumName(OrderDataInputFields, +(jsonObject["field"]))) {
        const inputFieldName = Utils.EnumName(OrderDataInputFields, +(jsonObject["field"]));
        if (+(jsonObject["field"]) !== OrderDataInputFields.email) {
          if (customerInputFieldViewModels.length > 0 && customerInputFieldViewModels.some(f => f.fieldName === Utils.EnumName(OrderDataAddressFieldInputs, +(jsonObject["field"])))) {
            const customerField = customerInputFieldViewModels.find(f => f.fieldName === Utils.EnumName(OrderDataAddressFieldInputs, +(jsonObject["field"])));
            customerField.isRequired = jsonObject[RequiredServiceTypeFieled.RequiredDelivery] || jsonObject[RequiredServiceTypeFieled.RequiredInHouse] || jsonObject[RequiredServiceTypeFieled.RequiredPickUp] || jsonObject[RequiredServiceTypeFieled.RequiredWebvoucher];
          } else {
            const customerInputFieldViewModel = new CustomerInputFieldViewModel();
            customerInputFieldViewModel.fieldName = Utils.EnumName(OrderDataInputFields, +(jsonObject["field"]));
            customerInputFieldViewModel.isRequired = jsonObject[RequiredServiceTypeFieled.RequiredDelivery] || jsonObject[RequiredServiceTypeFieled.RequiredInHouse] || jsonObject[RequiredServiceTypeFieled.RequiredPickUp] || jsonObject[RequiredServiceTypeFieled.RequiredWebvoucher];
            customerInputFieldViewModel.fieldType = jsonObject["type"];
            customerInputFieldViewModels.push(customerInputFieldViewModel);
          }
        }
      }
    });
    return customerInputFieldViewModels;
  }

  public saveCustomerMainAddressDataModel(webshopOrderDataViewModel: UserAddressViewModel): Promise<void> {
    const me = this;
    return new Promise<void>(async (resolve, reject) => {
      try {
        const billingInfo: { [key: string]: string | number } = {};
        for (const key in webshopOrderDataViewModel) {
          if (Object.prototype.hasOwnProperty.call(webshopOrderDataViewModel, key)) {
            billingInfo[key] = webshopOrderDataViewModel[key];
          }
        }
        await me._circularInjectionHelper.yourAppServer.User.SetCustomerMainAddress(billingInfo)
        await me._circularInjectionHelper.yourAppServer.User.GetUserInfo(true);
        resolve();
      } catch (error) {
        this._circularInjectionHelper.coreLogService.error("BillingInfoService.saveCustomerMainAddressDataModel", "try catch", error);
        reject();
      }
    })
  }

  private mapUserInfoToUserAddressViewModel(model: UserInfoData): UserAddressViewModel {
    const me = this;
    const viewModel = new UserAddressViewModel()
    viewModel.co = model.co;
    viewModel.address = model.address;
    viewModel.addition = model.addition;
    viewModel.zip_code = model.zip_code;
    viewModel.city = model.city;
    viewModel.country = model.country;
    return viewModel;
  }

}
